(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentSearchResults', [ContentSearchResultsDirective])
		.controller('ContentSearchResultsController',
		[
			'gettextCatalog',
			'smbToolbarService',
			'smbContentTypeGroupConfigDataStore',
			'smbContentTypeConfigDataStore',
			'smbIconTypes',
			'smbContentSearchDataStore',
			'smbDocumentViewerNavigationService',
			ContentSearchResultsController
		]);

	var templateUrl = require('./contentSearchResults.template');
	function ContentSearchResultsDirective() {
		return {
			restrict: 'E',
			controller: ContentSearchResultsController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				groupId: '@',
				typeId: '@'
			}
		};
	}

	function ContentSearchResultsController(gettextCatalog, smbToolbarService, smbContentTypeGroupConfigDataStore, smbContentTypeConfigDataStore, smbIconTypes, smbContentSearchDataStore, smbDocumentViewerNavigationService) {

		smbToolbarService.set(gettextCatalog.getString('Search Results'), 'search.contentTypeGroups.contentTypes.search');

		var vm = this;
		vm.contentSearchDS = smbContentSearchDataStore;
		vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
		vm.contentTypeDS = smbContentTypeConfigDataStore;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
		vm.documentNavigation = smbDocumentViewerNavigationService;

		(function loadSearchResults() {
			smbContentSearchDataStore.getDocuments(vm.groupId, vm.typeId);
		})();
	}
}());



//////////////////
// WEBPACK FOOTER
// ./app/components/contentSearchResults/contentSearchResults.js
// module id = 65
// module chunks = 1